import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TCcn } from '../../../core/interfaces/tccn.model';
import { CompanyCodeService } from '../../../core/services/adminService/company-code.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { Subscription } from 'rxjs';
import { constantTxt } from '../../../core/constants/constants';

@Component({
  selector: 'app-company-code',
  templateUrl: './company-code.component.html',
  styleUrls: ['./company-code.component.less'],
  imports: [
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
    NzButtonModule,
    NzInputModule,
    NzTableModule,
  ],
})
export class CompanyCodeComponent implements OnInit, OnDestroy {
  companyCodes: TCcn[] = [];
  addForm!: FormGroup;
  showAddFormPopup = false;
  selectedIds: Set<number> = new Set();
  customNoDataMessage = constantTxt.noDataFound;
  companiesSubscription!: Subscription;
  addCompanyCodeSubscription!: Subscription;
  pageSize = 50;

  constructor(
    private readonly fb: FormBuilder,
    private readonly companyCodeService: CompanyCodeService
  ) {}

  ngOnInit(): void {
    this.intializeForm();
    this.loadCompanyCodes();
  }

  intializeForm() {
    this.addForm = this.fb.group({
      ccnCode: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      ccnBranchPlant: ['', Validators.required],
    });
  }

  loadCompanyCodes() {
    this.companiesSubscription = this.companyCodeService
      .getCompanies()
      .subscribe({
        next: (res) => {
          let data = res.body;
          if (data) {
            this.companyCodes = data;
          }
        },
      });
  }

  addCompanyCode() {
    if (this.addForm.valid) {
      const newCode: TCcn = {
        ...this.addForm.value,
        ccnCode: this.addForm.value?.ccnCode.toString(),
        ccnBranchPlant: this.addForm.value?.ccnBranchPlant.toString(),
      };
      this.addCompanyCodeSubscription = this.companyCodeService
        .addCompanyCode(newCode)
        .subscribe(() => {
          this.loadCompanyCodes();
          this.addForm.reset();
          this.closePopup();
        });
    } else {
      this.addForm.markAllAsTouched();
      alert('Please fill all mandatory fields.');
    }
  }

  showAddForm() {
    this.showAddFormPopup = true;
  }

  closePopup() {
    this.addForm.reset();
    this.showAddFormPopup = false;
  }

  deleteSelected() {
    if (confirm('Are you sure to delete checked item?')) {
      const ids = Array.from(this.selectedIds);
      ids.forEach((id) => {
        this.companyCodeService.deleteCompanyCode(id).subscribe(() => {
          this.loadCompanyCodes();
          this.selectedIds.delete(id);
        });
      });
    }
  }

  toggleSelection(id: number) {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
  }

  ngOnDestroy(): void {
    this.addForm.reset();
    if (this.companiesSubscription) {
      this.companiesSubscription.unsubscribe();
    }
    if (this.addCompanyCodeSubscription) {
      this.addCompanyCodeSubscription.unsubscribe();
    }
  }
}
